// export const API=`https://62a97087ec36bf40bdb787e6.mockapi.io`;
// export const API=`https://myfirstmovie.herokuapp.com`;
// export const API=`http://localhost:4000`;
export const API=`https://movie-app-742c.onrender.com`